/* Copyright Verge Technologies 2018
 * @file favourites.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Favourites page
 */

// Modules
import React, { Component } from 'react';

// Components
import Header from '../../components/Header/header';
import Favourites from '../../components/Favourites/favourites';
import Footer from '../../components/Footer/footer';

class FavouritesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <div>
        <Header crumbs={this.props.crumbs} />
        <Favourites client={this.props.client} />
        <Footer />
      </div>
    );
  }
}

export default FavouritesPage;



// WEBPACK FOOTER //
// ./src/pages/favourites/favourites.page.js